
import React from 'react'
import irelandApi from '../irelandApi';

export const getLatestNews = () => (dispatch) => {
    dispatch({type: 'GET_LATEST_NEWS_PENDING', payload: []});
  
    return irelandApi.get('/api/articles')
                     .then(function (response) {
                       dispatch({
                         type: 'GET_LATEST_NEWS_FULFILLED',
                         payLoad: response.data
                       });
                     })
                     .catch(function (error) {
                       dispatch({type: 'GET_LATEST_NEWS_REJECTED', payLoad: error});
                     });
  };


// WEBPACK FOOTER //
// ./src/actions/latest-news.js